module.exports = "https://static.zego.com/_next/static/images/SecureFinance-4df48f8db6ea01e998c8abf397ba69d4.svg";